import { Fragment } from 'react'
import Image from 'next/image'

import * as S from './styles'

import { ASSET_PATHS } from '@/services/paths'

import type { RelatedUser } from '@/types/components/Modal/Templates/ShareCollection'

interface EmailRowProps {
  user: RelatedUser
  onRemove?: (user: RelatedUser) => void
  disabled?: boolean
  type?: 'success' | 'errors'
  index: number
}

function EmailRow({ user, onRemove, disabled, type, index }: EmailRowProps) {
  return (
    <S.SharedListEmailItem
      key={user.cognito_id}
      id={`list-email-item-${index}`}
      success={type === 'success'}
      errors={type === 'errors'}
    >
      <span>{user.email}</span>
      {!!onRemove && (
        <button
          onClick={() => onRemove(user)}
          id={`list-email-item-remove-btn-${index}`}
          disabled={disabled}
        >
          <Image
            src={ASSET_PATHS.icon_close}
            width={16}
            height={16}
            alt={'Close'}
          />
        </button>
      )}
    </S.SharedListEmailItem>
  )
}

interface EmailListsProps {
  lists: {
    key: string
    title?: string
    users: RelatedUser[]
    type?: 'success' | 'errors'
  }[]
  onRemove?: (user: RelatedUser) => void
  disabled?: boolean
}

export default function EmailLists({
  lists,
  onRemove,
  disabled
}: EmailListsProps) {
  return (
    <>
      <S.SharedListEmails>
        {lists.map(({ key, title, users, type }) => (
          <Fragment key={key}>
            {!!title && (
              <li>
                <span className="subtitle">{title}</span>
              </li>
            )}
            {users.map((item, index) => (
              <EmailRow
                key={index}
                user={item}
                onRemove={onRemove}
                disabled={disabled}
                type={type}
                index={index}
              />
            ))}
          </Fragment>
        ))}
      </S.SharedListEmails>
    </>
  )
}
